var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-color-picker',{staticClass:"rgb-base ma-0",attrs:{"value":_vm.sliderValue,"dot-size":"25","swatches-max-height":"200","hide-canvas":"","hide-mode-switch":"","hide-inputs":"","width":"100%","disabled":_vm.isDisabled},on:{"input":_vm.handleState}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }